import React from 'react';

import { getTranslation } from '../utils/translations';
import { SvgIcon } from './SvgIcon';
import { useDispatch } from 'react-redux';

export const StatsButton = () => {
    const dispatch = useDispatch();

    return (
        <button
            className="filter-button"
            aria-label={getTranslation('label.customTable.manageStatsButton')}
            onClick={() =>
                dispatch(
                    PULSE.app.redux.actions.customtable.TOGGLE_MODAL.request({
                        tableName: 'ladder'
                    })
                )
            }
        >
            <SvgIcon icon="manage" className="filter-button__icon" />

            <span className="u-hide-until-tablet">
                {getTranslation('label.customTable.manageStatsButton')}
            </span>
        </button>
    );
};
